import { Controller } from "@hotwired/stimulus"

// Toggles reminders configuration section based on checkbox
export default class extends Controller {
  static targets = ["config"]

  toggle(event) {
    if (event.target.checked) {
      this.configTarget.classList.remove("hidden")
    } else {
      this.configTarget.classList.add("hidden")
    }
  }
}
